import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/cards.css';

export default function ServiceCard({ service, featured = false }) {
  return (
    <Link 
      to={`/services/${service.slug}`} 
      className={`service-card ${featured ? 'featured' : ''}`}
      aria-label={`Learn more about our ${service.title} services`}
    >
      {service.image && (
        <div className="service-card-image-wrapper">
          <img src={service.image} alt={service.title} className="service-card-image animate-float" />
        </div>
      )}
      <div className="service-card-content">
        <span className="service-card-category">{service.category}</span>
        <h3 className="service-card-title">{service.title}</h3>
        <p className="service-card-desc">{service.description.slice(0, 115)}…</p>
        <div className="service-card-features">
          {service.features.slice(0, 3).map(f => (
            <span key={f} className="service-feature-tag">{f}</span>
          ))}
        </div>
        <div className="service-card-arrow">
          Learn more
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
          </svg>
        </div>
      </div>
    </Link>
  );
}
